import { useNavigate, useLocation } from "react-router-dom";

/**
 * A custom hook to navigate to the logical parent route of the current path.
 *
 * @param level - Number of path segments to retain from the start of the path.
 * For example, level=2 navigates to "/profile/{section}" from "/profile/{section}/{sub-section}".
 *  Default is 2.
 */
export function useExitToParent(level = 2) {
  const navigate = useNavigate();           // Used to perform navigation
  const { pathname } = useLocation();       // Access the current URL path

  return () => {
    // Split path into segments (filter removes empty strings from slashes)
    const segments = pathname.split("/").filter(Boolean);

    if (level >= segments.length ) {
      level = segments.length - 1;
    }
    // Keep only the first `level` segments to define the "parent"
    const newPath = "/" + segments.slice(0, level).join("/");

    // Navigate to the computed parent path, or to root ("/") if path is empty
    navigate(newPath || "/");
  };
}